module.exports = __webpack_public_path__ + "static/media/10.ef10f499.jpg";